// Port of api/fuel/app/classes/filter/search/games/filters/query/rating/group/votes.php
import F from 'offline/filter/constants'
export default {
	name: 'rating.group.votes',
	priority: 70,
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && filter.threshold && filter.threshold.group > 0
	},
	run: function(config, filter, data, query) {
		query.having('COUNT(DISTINCT(r.user_id))', '>=', filter.threshold.group)
	}
}
